<template>
  <div class="panel panel-body">
    <general-stepper
      :steps-info="stepsInfo"
      :enable-save-button="true"
      @finish="finished"
      @changeStep="changeStep"
    >
      <template
        slot="content-step-1"
        class="col-xs-12"
      >
        <SimpleForm
          v-model="formValues"
          @canFinishStep="finishStep(1)"
          @canNotFinishStep="notFinishStep(1)"
        />
      </template>

      <template
        slot="content-step-2"
        class="col-xs-12"
      >
        <EventFilter
          :form-values="formValues"
          @canFinishStep="finishStep(2)"
          @canNotFinishStep="notFinishStep(2)"
        />
      </template>

      <template
        slot="content-step-3"
        class="col-xs-12"
      >
        <CreateSyncActions
          :form-values="formValues"
          @canFinishStep="finishStep(3)"
          @canNotFinishStep="notFinishStep(3)"
        />
      </template>

      <template
        slot="content-step-4"
        class="col-xs-12"
      >
        <PreviewActions
          :form-values="formValues"
          @canFinishStep="finishStep(4)"
          @canNotFinishStep="notFinishStep(4)"
        />
      </template>
    </general-stepper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CreateSyncActions from './CreateSyncActions.vue'
import EventFilter from './EventFilter.vue'
import PreviewActions from './PreviewActions.vue'
import SimpleForm from './SimpleForm.vue'

export default {
  name: 'CreateSsrSteps',

  components: { CreateSyncActions, EventFilter, PreviewActions, SimpleForm },

  data () {
    return {
      formValues: {
        name: '',
        programId: null,
        startdate: null,
        enddate: null,
      },
    }
  },

  computed: {
    ...mapGetters([
      'filterJSON',
      'actionObj',
    ]),

    stepsInfo () {
      return this.$store.state.steps.steps_info
    },
  },

  watch: {
    formValues (newValue) {
      this.formValues.name = newValue.name
      this.formValues.programId = newValue.programId
      this.formValues.startdate = newValue.startdate
      this.formValues.enddate = newValue.enddate
    },

    classificationComponentValues (newValue) {
      this.classificationComponentValues.classificationConfig = newValue.classificationConfig
    },
  },

  created () {
    this.$store.dispatch('add_steps_info', {
      1: {
        step: 1,
        title: Lang.get('schedule_sync_rules.stepper.form'),
        finished: false,
      },
      2: {
        step: 2,
        title: Lang.get('schedule_sync_rules.stepper.events'),
        finished: false,
      },
      3: {
        step: 3,
        title: Lang.get('schedule_sync_rules.stepper.actions'),
        finished: false,
      },
      4: {
        step: 4,
        title: Lang.get('schedule_sync_rules.stepper.results'),
        finished: false,
      },
    },
    ).then(() => {
      this.$store.dispatch('set_active_step', { step: 1 })
    })
  },

  methods: {
    changeStep (event) {
      this.$store.dispatch('set_active_step', { step: event.step })
    },

    finishStep (stepNumber) {
      return this.$store.dispatch('update_step_finished', { step: stepNumber, finished: true })
    },

    notFinishStep (stepNumber) {
      return this.$store.dispatch('update_step_finished', { step: stepNumber, finished: false })
    },

    finished () {
      axios.post('/employee/schedulesyncrules', {
        program_id: this.formValues.programId,
        // startdate: this.formValues.startdate,
        // enddate: this.formValues.enddate,
        include: true,
        filter: this.filterJSON,
        actions: this.actionObj,
        data: { ...this.formValues, program_id: this.formValues.programId },
      }).then(response => {
        if ('redirect' in response.data) {
          window.location.href = response.data.redirect
        }
      })
    },
  },
}
</script>
  <style>
      .v-stepper {
          margin-bottom: 15px;
      }
  </style>
